import Icon from "@mui/material/Icon";
import Shop from "examples/Icons/Shop";

/**
 * Sidenav routes for guest demo (Dashboard, Missions, Entities, Leaderboard only).
 */
export const guestDemoNavRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Shop size="12px" />,
    route: "/dashboard",
    component: null,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Missions",
    key: "missions",
    icon: <Icon fontSize="small">flight</Icon>,
    route: "/dashboard/missions",
    component: null,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Entities",
    key: "entities",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/dashboard/entities",
    component: null,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Leaderboard",
    key: "leaderboards",
    icon: <Icon fontSize="small">emoji_events</Icon>,
    route: "/dashboard/leaderboards",
    component: null,
    noCollapse: true,
  },
];
